import xxhash from 'xxhash-wasm';

/**
 * Hashes the content of a File object using the 64-bit xxHash algorithm.
 * This implementation uses modern, standard APIs and assumes the library can
 * handle raw binary data, which is standard for WASM-based tools.
 *
 * @param {File} file The file to hash.
 * @returns {Promise<string>} A promise that resolves with the 64-bit hexadecimal hash string.
 */
const hashFile = async (file: File): Promise<bigint> => {
  try {
    const { h64 } = await xxhash();

    const buffer = await file.text();

    const hash = h64(buffer);

    return hash;
  } catch (error) {
    return BigInt(0);
  }
};

export default hashFile;
